import React, {Component} from "react";
import './novidades.css';
//import Modal from '../sitestruct/modal/Modal';
//import MovieDetails from "../sitestruct/movieDetails/MovieDetails";

class CoversRow extends Component{


    /**
     * Class constructor
     */
    constructor() {
        super();

        //schedules an update to a component state object. When state changes, the component responds rendering itself
        this.state = {
            /*modalShow: false,
            cssshow: ''*/

            movieDetailShow: false,
            cssshow: ''
        };

        //this.onclickFilmDetail = this.onclickFilmDetail.bind(this);
        this.oncover_click = this.oncover_click.bind(this);            //click action: show selected movie details (new page)
        //this.closeModal = this.closeModal.bind(this);                  //click action: close the opened modal
    }


    /**
    * This method runs after the component output has been rendered to the DOM.
    */
    componentDidMount() {
    }


    /**
     * Method to open movie details
     */
    /*onclickFilmDetail(){

        this.setState({
            /!*pageShow: true,
            cssshow:'show-modal',
            pagetitle:this.props.movie.title,
            pagecover: this.props.movie.poster_src,
            pageoverview: this.props.movie.overview,*!/

            modalShow: false,
            cssshow:'',
            modaltitle:this.props.movie.title,
            modalcover: this.props.movie.poster_src,
            modalmovieoriginaltitle: this.props.movie.original_title,
            modalmoviereleasedate: this.props.movie.release_date,
            modalbody:this.props.movie.overview
        });
    }*/


    /**
     * Method to add click action to movies cover. Movie opened through movie ID
     */
    oncover_click(){
        this.props.onclickcover(this.props.movie.id);
    }


    /**
     * Close modal (old!)
     */
    /*closeModal(){
        this.setState({
            modalShow: false,
            cssshow:'',

            /!*pageShow: false,
            cssshow: '',*!/
        });
    }*/


    /**
     * This method render the information (data from previous functions) with HTML code
     * @returns Return page information inside HTML
     */
    render() {
        return(
            <>
                <div className="row-cols-md-1 filme-container" >
                    <img src={this.props.movie.poster_src}  width="300" alt={this.props.movie.title}
                         className="img-margin"  onClick={this.oncover_click}
                    />
                </div>
            </>
        );
    }


}


export default CoversRow;
